const minimumPaymentAmountReducer = (state = 0, action) => {
	switch(action.type){
	case 'UPDATEMINIMUM':	
		return action.payload;
	default:
		return state;
	}
}

export default minimumPaymentAmountReducer;